import { Expense, ExpenseReportAPIModel, PaginatedAPI } from 'src/models/api.model'

export interface ExpenseState {
  expenseReportList: PaginatedAPI<ExpenseReportAPIModel>
  expenses: PaginatedAPI<Expense>
}

export const initialExpenseState: ExpenseState = {
  expenseReportList: undefined,
  expenses: undefined
}
